import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Cross from 'react-icons/lib/fa/times-circle';
import Button from 'react-bootstrap/lib/Button';
import Label from 'react-bootstrap/lib/Label';
import { Redirect } from 'react-router-dom';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from './Alert';
import ReactDOM from 'react-dom';
import ButtonGroup from './ButtonGroup';
import Info from 'react-icons/lib/fa/info-circle';
import CustomFormGroup from './CustomFormGroup';
import ProfileElementField from './ProfileElementField';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { generateProfileElementObject, changeState } from '../../utilities';
import { handleSelection} from '../../../../shared/utilities';

class GuestPreferences extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      preferredGender: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, 'Either', 'service', 'preferred_gender'),
      preferredAge: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, 'Either', 'service', 'preferred_age'),
      hostHighschoolStudent: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'host_highschool_student'),
      preferredHighschoolAge: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'preferred_highschool_age'),
      caregiversDriversLicense: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'caregivers_drivers_license'),
      highSchoolTransport: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'high_school_transport'),
      highSchoolTransportNotes: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'high_school_transport_notes'),
      hostUnder18: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'host_under_18'),
      parentNominatedHost: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'parent_nominated_host'),
      parentNominatedStudentName: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'service', 'parent_nominated_student_name'),
      preferredVaccinatedGuest: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, 'No preference', 'service', 'preferred_vaccinated_guest'),
      preferredAgeSelections: this.props.localProfileElements.elements.service.preferred_age_selections,
      preferredHighschoolAgeSelections: this.props.localProfileElements.elements.service.preferred_highschool_age_selections,
      preferredGenderSelections: this.props.localProfileElements.elements.service.preferred_gender_selections,
      preferredVaccinatedGuestSelections: this.props.localProfileElements.elements.service.preferred_vaccinated_guest_selections,
      highSchoolTransportSelections: this.props.localProfileElements.elements.service.high_school_transport_selections
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
    this.removeSchool = this.removeSchool.bind(this);
    this.addSchool = this.addSchool.bind(this);
    this.buildSubmitData = this.buildSubmitData.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  componentDidMount(){
    let placeSearch = ReactDOM.findDOMNode(this.refs.placeSearch);
    let addSchool = this.addSchool;
    $(placeSearch).autocomplete({
      source: `/places/autocomplete_with_google?host_id=${this.props.user.host.id}`,
      minLength: 2,
      autoFocus: true,
      delay: 100,
      select: function(e,ui){
        e.preventDefault();
        $(placeSearch).blur();
        placeSearch.value = '';
        if (ui.item.value != -1) {
          addSchool(ui.item.value, ui.item.google);
        }
      },
      focus: function(e,ui){
        e.preventDefault();
      }
    });
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  removeSchool(e, school){
    e.preventDefault();
    this.props.onUpdateSchools({
      authenticity_token: ReactOnRails.authenticityToken(),
      school_id: school,
      operation: 'remove'
    })
  }

  addSchool(school, google){
    this.props.onUpdateSchools({
      authenticity_token: ReactOnRails.authenticityToken(),
      school_id: school,
      operation: 'add',
      google: google
    })
  }

  unfamiliarSchoolsWarning(){
    const unfamiliarSchools = this.props.user.host.affiliated_schools.filter(s => !s.familiar)
    const content = this.props.content;
    if (unfamiliarSchools.length > 0) {
      return (
        <Alert alert={content.pages.guest_preferences.unfamiliar_schools} />
      )
    } else {
      return (null)
    }
  }

  schools(options){
    return(
      <div>
        {options.map(school =>
          <Label
            bsStyle={school.familiar ? 'primary' : 'danger'}
            key={school.id}
            className='school-label'>
            {school.name}
            <a
              className='trash-school'
              href="#"
              onClick={(e) => this.removeSchool(e, school.id)}>
              <Cross/>
            </a>
          </Label>
        )}
      </div>
    )
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  buildSubmitData() {
    const data = {
      preferred_gender: this.state.preferredGender.val,
      preferred_age: this.state.preferredAge.val,
      host_under_18: this.state.hostUnder18.val,
      parent_nominated_host: this.state.parentNominatedHost.val,
      parent_nominated_student_name:this.state.parentNominatedStudentName.val,
      preferred_vaccinated_guest: this.state.preferredVaccinatedGuest.val,
      host_highschool_student: this.state.hostHighschoolStudent.val,
      preferred_highschool_age: this.state.preferredHighschoolAge.val,
      caregivers_drivers_license: this.state.caregiversDriversLicense.val,
      high_school_transport: this.state.highSchoolTransport.val,
      high_school_transport_notes: this.state.highSchoolTransportNotes.val,
    }

    if (this.props.disableCovidQuestions === false) {
      delete data['preferred_vaccinated_guest']
    }

    return data
  }

  submit(e) {
    this.props.onHostProfileSubmit({ service: this.buildSubmitData() });
  }

  render() {
    const thisPage = P.GUEST_PREFERENCES_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const disableCovidQuestions = this.props.disableCovidQuestions;

    const willHostUnder18Label = content.territory_code == "srsc"
      ? formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsHostUnder18Srsc)
      : formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsHostUnder18)


    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.guest_preferences.title} icon={<Info />}/>
          <CheckboxOrRadioGroup
            title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsPreferredGender)}
            setName={'preferredGender'}
            type={'radio'}
            checkBoxStyle={'radio-inline'}
            controlFunc={e => this.changeState('preferredGender', e.target.value)}
            options={this.state.preferredGenderSelections}
            valid={this.state.preferredGender.valid}
            selectedOptions={[this.state.preferredGender.val]} />

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsPreferredAge)}
                setName={'preferredAge'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={e => this.changeState('preferredAge', e.target.value)}
                options={this.state.preferredAgeSelections}
                valid={this.state.preferredAge.valid}
                selectedOptions={[this.state.preferredAge.val]} />
            }
            elementName={'preferred_age'} />

          {content.territory_code == 'nz' && (
            <>
              <ProfileElementField
                childComponent={
                  <CheckboxOrRadioGroup
                    title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsHostHighschoolStudent)}
                    setName={'hostHighschoolStudent'}
                    type={'radio'}
                    checkBoxStyle={'radio-inline'}
                    controlFunc={e => this.changeState('hostHighschoolStudent', e.target.value == 'true')}
                    options={[
                      [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                      [formatMessage(defaultMessages.clientCommonNegative), 'false']
                    ]}
                    valid={this.state.hostHighschoolStudent.valid}
                    selectedOptions={[String(this.state.hostHighschoolStudent.val)]} />
                }
                elementName={'host_highschool_student'}
              />
              {this.state.hostHighschoolStudent.val == true && (
                <>
                  <ProfileElementField
                    childComponent={
                      <CheckboxOrRadioGroup
                        title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsPreferredHighschoolAge)}
                        setName={'preferredHighschoolAge'}
                        type={'radio'}
                        checkBoxStyle={'radio-inline'}
                        controlFunc={e => this.changeState('preferredHighschoolAge', e.target.value)}
                        options={this.state.preferredHighschoolAgeSelections}
                        valid={this.state.preferredHighschoolAge.valid}
                        selectedOptions={[this.state.preferredHighschoolAge.val]} />
                    }
                    elementName={'preferred_highschool_age'}
                  />
                  <ProfileElementField
                    childComponent={
                      <CheckboxOrRadioGroup
                        title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsCaregiversDriversLicense)}
                        setName={'caregiversDriversLicense'}
                        type={'radio'}
                        checkBoxStyle={'radio-inline'}
                        controlFunc={e => this.changeState('caregiversDriversLicense', e.target.value == 'true')}
                        options={[
                          [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                          [formatMessage(defaultMessages.clientCommonNegative), 'false']
                        ]}
                        valid={this.state.caregiversDriversLicense.valid}
                        selectedOptions={[String(this.state.caregiversDriversLicense.val)]} />
                    }
                    elementName={'caregivers_drivers_license'}
                  />
                  <ProfileElementField
                    childComponent={
                      <CheckboxOrRadioGroup
                        title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsHighSchoolTransport)}
                        setName={'highSchoolTransport'}
                        type={'checkbox'}
                        checkBoxStyle={'checkbox'}
                        controlFunc={e => this.changeState('highSchoolTransport', handleSelection(this.state.highSchoolTransport.val, e.target.value))}
                        options={this.state.highSchoolTransportSelections}
                        valid={this.state.highSchoolTransport.valid}
                        selectedOptions={this.state.highSchoolTransport.val} />
                    }
                    elementName={'high_school_transport'}
                  />
                  <ProfileElementField
                    childComponent={
                      <CustomFormGroup valid={this.state.highSchoolTransportNotes.valid}>
                        <ControlLabel>{formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsHighSchoolTransportNotes)}</ControlLabel>
                        <FormControl
                          componentClass="textarea"
                          id='highSchoolTransportNotes'
                          placeholder=""
                          style={{ width: '100%' }}
                          defaultValue={this.state.highSchoolTransportNotes.val}
                          onChange={e => this.changeState(e.target.id, e.target.value)} />
                      </CustomFormGroup>
                    }
                    elementName='high_school_transport_notes' />
                </>
              )}
            </>
          )}


          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={willHostUnder18Label}
                setName={'hostUnder18'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={e => this.changeState('hostUnder18', e.target.value == 'true')}
                options={[
                  [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                  [formatMessage(defaultMessages.clientCommonNegative), 'false']
                ]}
                valid={this.state.hostUnder18.valid}
                selectedOptions={[String(this.state.hostUnder18.val)]} />
            }
            elementName={'host_under_18'} />

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsParentNominatedHost)}
                setName={'parentNominatedHost'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={e => this.changeState('parentNominatedHost', e.target.value == 'true')}
                options={[
                  [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                  [formatMessage(defaultMessages.clientCommonNegative), 'false']
                ]}
                valid={this.state.parentNominatedHost.valid}
                selectedOptions={[String(this.state.parentNominatedHost.val)]} />
            }
            elementName={'parent_nominated_host'} />

          {this.state.parentNominatedHost.val && (
            <ProfileElementField
              childComponent={
                <CustomFormGroup>
                  <ControlLabel>{formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsParentNominatedStudentName)}</ControlLabel>
                  <FormControl
                    componentClass="input"
                    id='parentNominatedStudentName'
                    placeholder=""
                    style={{ width: '100%' }}
                    defaultValue={this.state.parentNominatedStudentName.val}
                    onChange={e => this.changeState(e.target.id, e.target.value)} />
                </CustomFormGroup>
              }
              elementName='parent_nominated_student_name' />
          )}

          {!disableCovidQuestions && (
            <ProfileElementField
              childComponent={
                <CheckboxOrRadioGroup
                  title={formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsPreferredVaccinatedGuest)}
                  setName={'preferredVaccinatedGuest'}
                  type={'radio'}
                  checkBoxStyle={'radio-inline'}
                  controlFunc={e => this.changeState('preferredVaccinatedGuest', e.target.value)}
                  options={this.state.preferredVaccinatedGuestSelections}
                  valid={this.state.preferredVaccinatedGuest.valid}
                  selectedOptions={[this.state.preferredVaccinatedGuest.val]}
                />
              }
              elementName={'preferred_vaccinated_guest'}
            />
          )}

          <ProfileElementField
            childComponent={
              <div>
                <CustomFormGroup>
                  <ControlLabel>{formatMessage(defaultMessages.clientHostPagesGuestPreferencesLabelsSchools)}</ControlLabel>
                  <FormControl id="place_search"
                    ref="placeSearch"
                    type="text"
                    placeholder="Search..."
                    style={{width: '100%'}}
                    onChange={this.invalidatePlaceId} />
                  {this.schools(this.props.user.host.affiliated_schools)}
                </CustomFormGroup>

                {this.unfamiliarSchoolsWarning()}
              </div>
            }
            elementName='schools' />

          {
            content.territory_code != "usa" || content.territory_code != "srsc" &&
            <Alert alert={content.pages.guest_preferences.info} />
          }

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>
      </div>
    )
  }
};

GuestPreferences.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(GuestPreferences);
